module.exports = __webpack_public_path__ + "static/media/fz_verifylocal_pt_BR.c1912cf5.png";